import classNames from 'classnames';

import { useCatalogRouteMatch } from '@utils/common';
import { NavLayout } from '@layouts/NavLayout';
import { CatalogContainer } from '@containers/catalog/Catalog';
import { useGotchaWebVitals } from '@hook/useGotchaWebVitals';

import s from './CatalogPage.sss';

type CatalogPageProps = {
  className?: string
};

export const CatalogPage: React.FC<CatalogPageProps> = ({
  className,
}) => {
  const match = useCatalogRouteMatch();

  useGotchaWebVitals({ pageName: 'catalog' });

  if (!match) {
    throw new Error('Not match');
  }

  const { params } = match;
  return (
    <NavLayout className={classNames(s.root, className)}>
      <CatalogContainer
        namespace={params.namespace}
        slug={'slug' in params ? params.slug : undefined}
        citySlug={'city' in params ? params.city : undefined}
      />
    </NavLayout>
  );
};

export default CatalogPage;
